import { Box, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { EditBase, Form, required, SelectInput, useGetList, useGetOne, useRecordContext } from "react-admin";
import { setBranch } from "../api/backoffice.api";
import { DrivingSchool } from "../providers/drivingSchoolsProvider";
import { Student } from "../providers/studentsProvider";
import { DialogCloseButton } from "../misc/DialogCloseButton";
import { useState } from "react";
import { FieldValues } from "react-hook-form";
import { SaveButton2 } from "../buttons/SaveButton2";
import { Branch } from "../providers/branchesProvider";

export function ChangeStudentBranchDialog(props: { open: boolean; onClose: () => void }) {
  const { open, onClose } = props;
  const student = useRecordContext<Student>();
  const [saving, setSaving] = useState(false);
  const { data: drivingSchool, error: drivingSchoolError } = useGetOne<DrivingSchool>("drivingSchools", {
    id: student.drivingSchoolId,
  });
  const { data: activeBranches } = useGetList<Branch>(
    "branches",
    {
      filter: { drivingSchoolId: drivingSchool?.id },
      pagination: { page: 1, perPage: 1000 },
      sort: { field: "name", order: "ASC" },
    },
    { enabled: !!drivingSchool?.id },
  );

  const onSubmit = async (data: FieldValues) => {
    if (!student) {
      throw new Error("Invalid state: !student");
    }
    const { branchId } = data as { branchId: string };
    if (!branchId) {
      throw new Error("No branch selected");
    }
    setSaving(true);
    await runSafely(() => setBranch(student, branchId), {
      errorMessage: `Fehler beim Ändern der Filiale.`,
      successMessage: `Filiale erfolgreich geändert.`,
      onSuccess: onClose,
    });
    setSaving(false);
  };

  const choices = activeBranches?.map((branch) => ({
    id: branch.id,
    name: branch.name,
  }));

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Filiale von {student.name} ändern</DialogTitle>
      <DialogCloseButton onClick={onClose} />
      <EditBase redirect={false} mutationMode="pessimistic" mutationOptions={{ onSuccess: onClose }}>
        <Form onSubmit={onSubmit}>
          <DialogContent sx={{ width: "360px" }}>
            <SelectInput
              fullWidth
              source="branchId"
              label="Filiale"
              choices={choices}
              validate={required()}
              disabled={saving}
              helperText={drivingSchoolError ? <Box color="red">Fehler beim Laden der Filialen.</Box> : undefined}
            />
          </DialogContent>
          <DialogActions>
            <SaveButton2 />
          </DialogActions>
        </Form>
      </EditBase>
    </Dialog>
  );
}
